import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitBooking = (payload) => api.post("/bookings", payload).then((r) => r.data);

export const adminHeaders = () => ({
  headers: { "X-Admin-Key": sessionStorage.getItem("ert_admin_key") || "" },
});

export const verifyAdmin = (key) =>
  api.post("/admin/verify", {}, { headers: { "X-Admin-Key": key } }).then((r) => r.data);

export const fetchBookings = () => api.get("/bookings", adminHeaders()).then((r) => r.data);

export const updateBookingStatus = (id, status) =>
  api.patch(`/bookings/${id}`, { status }, adminHeaders()).then((r) => r.data);

export const deleteBooking = (id) => api.delete(`/bookings/${id}`, adminHeaders()).then((r) => r.data);

export const fetchAvailability = (month) => api.get(`/availability?month=${month}`).then((r) => r.data);

export const blockDay = (date) => api.post("/blocked-days", { date }, adminHeaders()).then((r) => r.data);

export const unblockDay = (date) => api.delete(`/blocked-days/${date}`, adminHeaders()).then((r) => r.data);
